<section [ngClass]="isDesktopDevice ? 'no-device' : 'device'">
    <router-outlet></router-outlet>
</section>
